/*
 * מזהה חדר.
 *
 * **הקובץ הזה משותף ללקוח ול-Worker** (‏`worker/src/index.ts` מייבא אותו). זו לא
 * נוחות: אלפבית שונה בשני הצדדים משמעו שהשרת מגריל קוד שהלקוח פוסל בעצמו, ואין
 * שום טסט שיתפוס את זה — רק משתמש שמנסה להצטרף ומקבל "קוד לא תקין".
 *
 * **האלפבית בלי 0/O ובלי 1/I בכוונה.** הקוד נאמר בטלפון ("תצטרף ל-K7QM"), וזוג
 * התווים הדומים האלה הוא מקור התקלה היחיד שאפשר לחזות מראש. 32 תווים בארבע
 * מקומות = ~1,048,576 צירופים, שזה הרבה מעל מספר החדרים שיהיו פתוחים בו-זמנית.
 */

export const ROOM_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

export const ROOM_CODE_LENGTH = 4;

/**
 * מנקה קלט אנושי: אותיות גדולות, בלי רווחים ומקפים, בלי תווים שאינם באלפבית.
 * מחזירה מחרוזת באורך 0..ROOM_CODE_LENGTH — לא בהכרח קוד תקין.
 */
export function normalizeRoomCode(raw: string): string {
    let out = '';
    for (const char of raw.toUpperCase()) {
        if (ROOM_ALPHABET.includes(char)) out += char;
        if (out.length === ROOM_CODE_LENGTH) break;
    }
    return out;
}

export function isRoomCode(value: string): boolean {
    return value.length === ROOM_CODE_LENGTH && normalizeRoomCode(value) === value;
}

/**
 * מגריל קוד חדר. מקבל מקור אקראיות מבחוץ כדי שיהיה אפשר לבדוק אותו.
 * `random` מחזירה מספר ב-[0,1) — בדיוק כמו `Math.random`.
 */
export function generateRoomCode(random: () => number): string {
    let out = '';
    for (let i = 0; i < ROOM_CODE_LENGTH; i++) {
        const index = Math.min(ROOM_ALPHABET.length - 1, Math.floor(random() * ROOM_ALPHABET.length));
        out += ROOM_ALPHABET[index];
    }
    return out;
}
